import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { FC } from "react";

import { MarkdownText } from "@app/shared/ui/MarkdownText";

import styles from "./AnnouncementMessageContent.module.scss";

type Props = {
  text: string;
  announcementCount: number;
  totalAnnouncements: number;
  onClose: () => void;
};

export const AnnouncementMessageContent: FC<Props> = ({
  text,
  announcementCount,
  totalAnnouncements,
  onClose,
}) => {
  return (
    <div className="flex align-center gap-10">
      <MarkdownText text={text} />
      <div className="flex align-center gap-5">
        {totalAnnouncements > 1 && (
          <span className={styles.counter}>
            {announcementCount}/{totalAnnouncements}
          </span>
        )}
        <Button
          type="text"
          size="middle"
          onClick={onClose}
          className="flex align-center justify-center p-0"
        >
          <CloseOutlined />
        </Button>
      </div>
    </div>
  );
};

export const AnnouncementMessageContentMobile: FC<Props> = ({
  text,
  announcementCount,
  totalAnnouncements,
  onClose,
}) => {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex align-center justify-end gap-5">
        {totalAnnouncements > 1 && (
          <span className={styles.counter}>
            {announcementCount}/{totalAnnouncements}
          </span>
        )}
        <Button
          type="text"
          size="middle"
          onClick={onClose}
          className="flex align-center justify-center p-0"
        >
          <CloseOutlined />
        </Button>
      </div>
      <MarkdownText text={text} className="break-all" />
    </div>
  );
};
